const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const fetchCategories = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/admin/categories/`);
    if (!response.ok) {
      throw new Error('Failed to fetch categories');
    }

    const categories = await response.json();

    // Mueve 'Uncategorized' al principio de la lista
    const uncategorizedIndex = categories.findIndex(category => category.name.toLowerCase() === 'uncategorized');
    if (uncategorizedIndex !== -1) {
      const [uncategorized] = categories.splice(uncategorizedIndex, 1);
      categories.unshift(uncategorized);
    }

    return categories;
    
  } catch (error) {
    console.error('Fetch error:', error);
    throw error;
  }
};

export const addCategory = async (categoryData) => {
  try {
    const response = await fetch(`${API_BASE_URL}/admin/categories/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(categoryData),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Failed to add category');
    }
    const category = await response.json();
    return category
  } catch (error) {
    console.error('Error adding category:', error);
    throw error; // Lanzar el error para que lo maneje el frontend
  }
};

export const updateCategory = async (categoryId, categoryData) => {

  try {
    const response = await fetch(`${API_BASE_URL}/admin/categories/${categoryId}/`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(categoryData),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Failed to update category');
    }
    const updatedCategory = await response.json()
    return updatedCategory
  } catch (error) {
    console.error('Error updating category:', error);
    throw error;
  }
};

export const deleteCategory = async (categoryId) => {
  try {
    const response = await fetch(`${API_BASE_URL}/admin/categories/${categoryId}/`, {
      method: 'DELETE',
    });
    if (!response.ok) {
      throw new Error('Failed to delete category');
    }
  } catch (error) {
    console.error('Error deleting category:', error);
    throw error;
  }
};

export const deleteCategories = async (categoryIds) => {
  try {
    const response = await fetch(`${API_BASE_URL}/admin/categories/bulk-delete/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        category_ids: categoryIds,
      }),
    });
    if (!response.ok) {
      throw new Error('Failed to delete categories');
    }
  } catch (error) {
    console.error('Error deleting categories:', error);
    throw error;
  }
};
